import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { JsonPipe } from '@angular/common';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { LoginService } from '../../../services/login/login.service';
import { AuthService } from '../../../services/auth/auth.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  isLoading = false;
  errorCredenciales = false;
  user: any = {};

  constructor(
    private _loginService: LoginService,
    private _authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit() {
    if (this._authService.isLoged()) {
      this.identifyRedirect();
    }
  }

  onSubmit() {
    this.isLoading = true;
    this.errorCredenciales = false;
    this._loginService.authentication(this.user.mail, this.user.password)
      .subscribe( data => {
        this.isLoading = false;
        this._authService.setToken(data.token);
        this.evaluateRol();
        },
      (error) => {
        this.isLoading = false;
        if (error.status === 401 || error.status === 404) {
          this.errorCredenciales = true;
        }
      });
  }

  private evaluateRol() {
    const isAdmin = this._authService.isAdmin();
    if (isAdmin) {
      this.router.navigate(['/administrador/admin-sitio']);
    } else {
      // this.router.navigate(['/administrador/admin-sitio/listado-codigos']);
      this.goToCotizaciones();
    }
  }

  private identifyRedirect() {
    const isAdmin = this._authService.isAdmin();
    if (isAdmin) {
      this.router.navigate(['/administrador/admin-sitio']);
    } else {
      this.router.navigate(['/administrador/admin-sitio/listado-codigos']);
    }
  }

  private goToCotizaciones() {
    const token = this._authService.getToken();
    const url = environment.COTIZACIONES_URL + 'auth?t=' + token;
    window.location.href = url;
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/login/login.component.ts